import React from 'react';
import {Link} from 'react-router-dom';
import { assetPath } from '../../data/companyData';

export default class FeatureFour extends React.Component {
    render(){
        return (
            <>
                {/* Start Feature Four */}
                <section className="feature-four">
                    <div className="container">
                        <div className="sec-title text-center">
                            <div className="sec-title__tagline">
                                <span className="left"></span>
                                <h6>WHY CHOOSE US</h6> <span className="right"></span>
                            </div>
                            <h2 className="sec-title__title">Craftsmanship built around your space</h2>
                        </div>
                        <div className="row">
                            {/* Start Feature Four Single */}
                            <div className="col-xl-4">
                                <div className="feature-four__single">
                                    <div className="feature-four__single-img">
                                        <img src={assetPath("gallery-02-kitchen-cabinetry.jpeg")} alt="Custom kitchen cabinetry" />
                                    </div>
                                </div>
                            </div>
                            {/* End Feature Four Single */}

                            {/* Start Feature Four Single */}
                            <div className="col-xl-4">
                                <div className="feature-four__single style2 text-center">
                                    <div className="feature-four__single-icon">
                                        <span className="icon-interior-design-1"></span>
                                    </div>
                                    <div className="feature-four__single-content">
                                        <span>EXPLORE THE FEATURES</span>
                                        <h2><Link to={process.env.PUBLIC_URL + `/services`}>Personalized Planning</Link></h2>
                                        <p>Each project starts with your goals, layout, budget, and the details that make the space work for daily life.</p>
                                    </div>
                                </div>
                            </div>
                            {/* End Feature Four Single */}

                            {/* Start Feature Four Single */}
                            <div className="col-xl-4">
                                <div className="feature-four__single">
                                    <div className="feature-four__single-img">
                                        <img src={assetPath("gallery-12-mudroom-bench.jpeg")} alt="Custom mudroom bench and trim" />
                                    </div>
                                </div>
                            </div>
                            {/* End Feature Four Single */}

                            {/* Start Feature Four Single */}
                            <div className="col-xl-4">
                                <div className="feature-four__single style2 text-center">
                                    <div className="feature-four__single-icon">
                                        <span className="icon-crane"></span>
                                    </div>
                                    <div className="feature-four__single-content">
                                        <span>EXPLORE THE FEATURES</span>
                                        <h2><Link to={process.env.PUBLIC_URL + `/services`}>Clean Installation</Link></h2>
                                        <p>From built-ins to trim and remodeling, the team focuses on careful preparation, alignment, and finish quality.</p>
                                    </div>
                                </div>
                            </div>
                            {/* End Feature Four Single */}

                            {/* Start Feature Four Single */}
                            <div className="col-xl-4">
                                <div className="feature-four__single">
                                    <div className="feature-four__single-img">
                                        <img src={assetPath("gallery-13-custom-closet.jpeg")} alt="Custom closet storage" />
                                    </div>
                                </div>
                            </div>
                            {/* End Feature Four Single */}

                            {/* Start Feature Four Single */}
                            <div className="col-xl-4">
                                <div className="feature-four__single style2 text-center">
                                    <div className="feature-four__single-icon">
                                        <span className="icon-painting"></span>
                                    </div>
                                    <div className="feature-four__single-content">
                                        <span>EXPLORE THE FEATURES</span>
                                        <h2><Link to={process.env.PUBLIC_URL + `/contact`}>Free Estimate</Link></h2>
                                        <p>Residential and commercial clients can request clear guidance before the first cut, coat, or installation.</p>
                                    </div>
                                </div>
                            </div>
                            {/* End Feature Four Single */}
                        </div>
                    </div>
                </section>
                {/* End Feature Four */}
            </>
        )
    }
}
